import React from "react";
import { CommonButton } from "../../Input";

const Step6TransactionReceipt = ({ onClose }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center h-100"
      style={{ minHeight: "400px" }}
    >
      <div className="text-center">
        <div className="mb-4">
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="40" cy="40" r="40" fill="#E8F5E9" />
            <path
              d="M55 28L34 49L25 40"
              stroke="#10B981"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2 className="fw-bold text-success mb-3 fs-28">
          Transaction Created Successfully!
        </h2>
        <p className="text-muted mb-5 fs-15" style={{ maxWidth: "500px" }}>
          The transaction has been created and is waiting for the admin's
          approval. You can now download, print, or email the receipt.
        </p>
        <div>
          <CommonButton onClick={onClose} className="px-5">
            Done
          </CommonButton>
        </div>
      </div>
    </div>
  );
};

export default Step6TransactionReceipt;
